$('.tego-displaytag').displaytag();
$('.tego-displaytag-autre').displaytag();
/*{
    "code": "all",
    "libelle": "Tous les conseils"
},
{
    "code": "sante",
    "libelle": "santé"
},
{
    "code": "prevoyance",
    "libelle": "prévoyance"
},
{
    "code": "habitation",
    "libelle": "habitation"
},
{
    "code": "auto",
    "libelle": "véhicule"
},
{
    "code": "epargne",
    "libelle": "épargne"
},
{
    "code": "retraite",
    "libelle": "retraite"
},
{
    "code": "entraide",
    "libelle": "entraide"
}*/
